<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
$fa-font-path: "~font-awesome/fonts";
$mdi-font-path: '~mdi/fonts';
@import '~bulma/sass/utilities/_all';

$primary: #5b5a9e;
$primary-invert: findColorInvert($primary);
$navbar-height: 1rem;

$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert)
);

$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

@import '~font-awesome/scss/font-awesome';
@import '~mdi/scss/materialdesignicons';
@import '~bulma/sass/utilities/_all';
@import "~bulma";
@import "~buefy/src/scss/buefy";

body {
  font-family: 'Jura', sans-serif;
  background-size: cover;
  background-color: #96468a;
  background-image: -moz-linear-gradient( 135deg, rgba(45, 6, 89, 0.8) 0%, rgba(255, 38, 141, 0.8) 100%);
  background-image: -webkit-linear-gradient( 135deg, rgba(45, 6, 89, 0.8) 0%, rgba(255, 38, 141, 0.8) 100%);
  background-image: -ms-linear-gradient( 135deg, rgba(45, 6, 89, 0.8) 0%, rgba(255, 38, 141, 0.8) 100%);
  background-image: linear-gradient( 135deg, rgba(45, 6, 89, 0.8) 0%, rgba(255, 38, 141, 0.8) 100%);
  height: 100%;
  position: absolute;
  width: 100%;
}

button {
  font-family: 'Jura', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue